// CrearListaDialog.jsx
import React from 'react';
import { useEffect, useState } from 'react';
import { fetchCategorias } from '../../../utils/generalsFetch';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
} from '@mui/material';
import Selector from '../../../components/Selector';

const CrearListadePreciosDialog = ({ open, onClose}) => {
  
  const [lista, setLista] = useState({
    nombre: '',
    descripcion: '',
  });
    
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCategorias({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') }).then(data => {
      setCategorias(data);
    })
  }, []);

  // Validation function
  const validateFields = () => {
    let newErrors = {};
    if (!lista.nombre || lista.nombre.trim() === "") {
      newErrors.nombre = "El nombre de la lista es obligatorio.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  async function onGuardar(){
    if (!validateFields()) {
      return;
    }

    const url = `${process.env.REACT_APP_SERVER_URL}/api/listaprecios`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          nombre: lista.nombre,
          descripcion: lista.descripcion,
          idcompany: localStorage.getItem('idcompany')
        })
      });

      if (!response.ok) {
        const error = await response.json();
        setErrors(prev => ({...prev, general: error.error || 'Error al crear lista de precios'}));
        throw new Error(error.error || 'Error al crear lista de precios');
      }

      onClose();

    } catch (error) {
      setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
      throw error;
    }

  }
  
  
  const handleChange = (field) => (event) => {
    setLista({ ...lista, [field]: event.target.value });

  };



  // Handler to set only one tipoPrecio at a time
  const handleTipoPrecioChange = (tipo) => () => {
    setLista({
      ...lista,
      tipoPrecio: lista.tipoPrecio === tipo ? null : tipo,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Crear nueva lista de precios</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>

        <TextField
          fullWidth
          margin="normal"
          placeholder="Nombre de la lista"
          value={lista.nombre}
          onChange={handleChange('nombre')}
          error={!!errors.nombre}
          helperText={errors.nombre}
        />

        <TextField
          fullWidth
          margin="normal"
          placeholder="Descripción de la lista"
          value={lista.descripcion}
          onChange={handleChange('descripcion')}
          error={!!errors.descripcion}
          helperText={errors.descripcion}
        />


      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>Cancelar</Button>
        <Button color='primarybutton' sx={{fontWeight:"bold"}} variant="contained" onClick={onGuardar}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CrearListadePreciosDialog;
